
const Footer = () => (
  <footer className="py-5 sm:px-10 px-5">
    <div className="screen-max-width">
      <div>
        <p className="font-semibold text-gray text-xs">
          More ways to Connect{" "}
          <span className="underline text-blue">Contact </span>
          or <span className="underline text-blue">Email </span> 
        </p>

        <p className="font-semibold text-gray text-xs">
          Or call +91 9962021086
        </p>
      </div>

      <div className="bg-neutral-700 my-5 h-[1px] w-full" />

      <div className="flex md:flex-row flex-col md:items-center justify-between">
        <p className="font-semibold text-gray text-xs">
          Copyright @ {new Date().getFullYear()} Mohamed Mafaz. All rights reserved.
        </p>

       
      </div>
    </div>
  </footer>
);

export default Footer;
